import { createContext, useContext, useEffect, useState } from "react";

const PendingUserContext = createContext();

export const usePendingUser = () => useContext(PendingUserContext);

export const PendingUserProvider = ({ children }) => {
  const [pendingUser, setPendingUser] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(
    () => JSON.parse(localStorage.getItem("termsAccepted")) || false
  );
  const [userPriviledges, setUserPriviledges] = useState({});

  useEffect(() => {
    localStorage.setItem("termsAccepted", JSON.stringify(termsAccepted));
  }, [termsAccepted]);

  return (
    <PendingUserContext.Provider
      value={{
        pendingUser,
        setPendingUser,
        termsAccepted,
        setTermsAccepted,
        userPriviledges,
        setUserPriviledges,
      }}>
      {children}
    </PendingUserContext.Provider>
  );
};

export default PendingUserContext;
